import React,{useState, useEffect} from "react";
import { Link, useNavigate, useParams } from 'react-router-dom'
import axios from "axios";
import { api, attendeeEventURL, eventURL, registerEventURL } from "../../../apis/urls";
import Loader from "../../../common-components/loader";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ReactPaginate from 'react-paginate';
import { $ } from "react-jquery-plugin";
import { decode } from "html-entities";
import moment from "moment/moment";
import { Table, Toggle,Pagination } from "rsuite";
import { Badge, message } from "antd";

const { Column, HeaderCell, Cell } = Table;

const RegitserListingDetails = () => {

    useEffect(() => {
        setLoader(true);
        $('body').removeClass('sidebar-collapsed sidebar-active').addClass('');
        setTimeout(() => {
            Listing();
            });
    }, []);

    const [loader,setLoader] = useState(true);
    const [loader1,setLoader1] = useState(true);

    const [result,setResult] = useState([]);
    const [aresult,setAResult] = useState([]);
    const [pendings, setPendings] = useState('');
    const [searchTitle, setSearchTitle] = useState("");
    const [alertText, setAlertText] = useState("");
    const [added, setAdded] = useState(false);
    const [currentpage, setCurrentpage] = useState([]);
    const [totalPages, setTotalPages] = useState([]);
    const [totalItems, setTotalItems] = useState([]);




    const [eventname, setEventname] = useState('')

    const [regList, setRegList] = useState(true);

    let {eventid} = useParams();



    let counts = 0;
    if(result)
    {
        counts = result.length;
    }


    useEffect(() => {

        if(added == true){

            const notify = () => toast.success("Removed Successfully!..", {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 500
              });

              notify();
        }
      }, [added])

    let navigate = useNavigate();

    const Listing = () => {

        let token = "Bearer "+localStorage.getItem('token');
        
        const instance = axios.create({

            baseURL: registerEventURL+eventid+'?page='+0+'&size='+10,

            timeout: 1000000,

            headers: {'authorization': token}

          });
          
          instance.get('').then((response) =>{

            console.log("daaaas",response.data.data);
            setEventname(response.data.eventname)
            setPendings(response.data.pendingData)
            if(response.data.message === "Success"){            
                setResult(response.data.data.items);
                setCurrentpage(response.data.data.currentPage)
                setTotalPages(response.data.data.totalPages)
                setTotalItems(response.data.data.totalItems)
                setLoader1(false)
            }else{
                setResult(response.data.data); 
                setLoader1(false)
            }
            
          }).catch((error) =>{
            
            console.log('error',error.message)
            

          });
    }





        let token = "Bearer "+localStorage.getItem('token');
        const instances = axios.create({
            baseURL: api,
            timeout: 1000000,
            headers: {'authorization': token}
        });

        const findByTitles = name => {
            return instances.get(`cm/event?search=${name}`);
        };

        const onChangeSearchTitle = (e) => {
            const searchTitle = e.target.value;
            setSearchTitle(searchTitle);
            findByTitles(searchTitle)
            .then(response => {
                if(response.data.message=== "Success"){
                    setResult(response.data.data.items)
                }else{
                    setResult(false)
                }
            })
            .catch(e => {
                console.log(e);
            });
        };

        const findByTitlesss = option => {
            return instances.get(`cm/event?status=${option}`);
        };

        const onChangeSearchTitles = (e) => {
            const searchTitle = e.target.value;
            findByTitlesss(searchTitle)
            .then(response => {
                if(response.data.message=== "Success"){
                    setResult(response.data.data.items)
                }else{
                    setResult(false)
                }
            })
            .catch(e => {
                console.log(e);
            });
        };


    //PAGINATION


     // Invoke when user click to request another page.






 const handlePageClick1 = (event) => { console.log('EVENTSSS',event)

 const instance = axios.create({
     baseURL: registerEventURL+eventid+'?page='+event.selected+'&size='+10,
     timeout: 1000000,
     headers: {'authorization': token}
   });

   

 instance.get('').then(res => {

     setResult(res.data.data.items)
     setCurrentpage(res.data.data.currentPage)
     setTotalPages(res.data.data.totalPages)
     setTotalItems(res.data.data.totalItems)

 
 
     setLoader1(false);
 }).catch(e => {
 //console.log('errorshw',e);
 localStorage.removeItem('token')
 navigate("/")
 });

};



 const attendeesBtn =()=>{
    setRegList(false);
 }

 const registerBtn =()=>{
    setRegList(true);
 }



 const exportAttendee  = () => { 

        let token = "Bearer "+localStorage.getItem('token');

        const instance = axios.create({
            baseURL: api+"impex/seminar/attendee/"+eventid,
            timeout: 1000000,
            headers: {'authorization': token}
        });
        instance.get('').then((response) =>{
            message.success("Export successfully")
            window.open(api+"impex/download/seminar/"+response.data.fileName, '_blank')
        }).catch((error) =>{     
            console.log('error',error.message)  
        });
}


    let sl =1;
    return (
        <div className="wrapper">
              <aside className="right-side ">
              <div class="content-area">
                  <div className="page-title-wrpr">
                      <div className="page-title-left-column">
                          <i className="icon-suitcase1"></i>
                          <h2 className="page-title">Attendees - {decode(eventname)}</h2>
                      </div>
                      <div className="page-rightside-action-column">
                          
                        <Badge count={pendings}>
                            <Link to={"/check_payment/"+eventid} data-toggle="tooltip" title="" class="addbtnitem-link text-anchor" data-original-title="Add New Event"><span>Check Payment Pending</span> </Link>
                        </Badge>

                      </div>
                  
                  </div>

                  <nav aria-label="breadcrumb">
                      <ol className="breadcrumb">
                          <li className="breadcrumb-item"><Link to="/dashboard">Home</Link></li>
                          <li className="breadcrumb-item active" aria-current="page"><Link to="/conference">Seminar</Link></li>
                          <li className="breadcrumb-item active" aria-current="page">Attendees</li>

                      </ol>
                  </nav>

                  {result?
                        <div className="page-title-wrpr" style={{marginTop:'40px'}}>
                            <div className="page-title-left-column">
                                Displaying {(currentpage*10 )+ 1}-{(currentpage*10 )+ counts} of {totalItems} results.
                            </div>
                            <div className="page-rightside-action-column">                          
                                <button style={{padding:"10px", background:'#4077c7', borderRadius:"5px", color:'#fff'}} class="addbtnitem-link text-anchor" onClick={exportAttendee}>Export</button>
                            </div>
                        </div>:null
                    }


                  <div className="jobs-list-wrpr list-wrpr">




                  <div style={{marginBottom:'30px',}}>
                </div>

                      {result?(
                      result?.map((item,index) =>
                          (
                              <div className="list " key={index}>
                                    <h6>Registers</h6>

                                  <div className="row">

                                      <div className="col-md-1">
                                      <div class="jobs-user">
                                          Sl.No
                                          <span class="desig">{(index+1)+currentpage*10}</span>
                                      </div>
                                      </div>

                                      
                                      <div className="col-md-3">
                                          <div className="jobs-user">
                                              Name
                                              <span class="desig"> {decode(item.firstname)+' '+ item.lastname}</span>
                                          </div>
                                      </div>

                                      <div className="col-md-3">
                                          <div className="jobs-user">
                                          Title & Email
                                              <span class="desig"> {item.reg_title}<br />
                                              {item.email}
                                              </span>    
                                          </div>
                                      </div>

                                      <div className="col-md-3">

                                      </div>
       


                                  
                                      <div className="col-md-2">
                                          <div className="list-action-wrpr text-right  roundicons-text">

                                                {/* <Link to={"/attendee/workshop/"+item.id} style={{pointerEvents:item.workshop_attendees.length ===0?"none":"visible", }}  data-toggle="tooltip" title="Attendees">
                                                    <i data-count={item.workshop_attendees.length} className="icon-baseball data-counts-icon"  style={{backgroundColor:'#0A95FF'}}></i>
                                                    <span>Attendees</span>
                                                </Link> */}

                                              <Link  to={"/register_view/"+eventid+'/'+item.id} data-toggle="tooltip" title="View" ><i className="edit icon-eye"></i><span>View</span></Link>  



                                          </div>
                                      </div>
                                      {/* <div>
                                          <ToastContainer
                                              style={{width: 578, marginTop: '10%', marginLeft: '8.3%'}}
                                              toastStyle={{backgroundColor: "#e74c3c", color: 'white', fontSize: 16}}
                                              progressStyle={{backgroundColor: 'white'}} 
                                          />
                                      </div> */}
                                  </div>
                                  <div>
                                    <h6>Attendees</h6>
                                    {item.event_attendees.map((items, indexx) => (
                                        <div className="row">
                                      <div className="col-md-1">
                                      <div class="jobs-user">
                                          Sl.No
                                          <span class="desig">{indexx+1}</span>
                                      </div>
                                      </div>

                                      
                                      <div className="col-md-3">
                                          <div className="jobs-user">
                                              Name
                                              <span class="desig"> {decode(items.firstname)+' '+ items.lastname}</span>
                                          </div>
                                      </div>

                                      <div className="col-md-3">
                                          <div className="jobs-user">
                                          Title & Email
                                              <span class="desig"> {items.reg_title}<br />
                                              {items.email}
                                              </span>    
                                          </div>
                                      </div>

                                      <div className="col-md-2">
                                        <div className="jobs-user">
                                            Payment Mode
                                            <span class="desig" style={{fontWeight:900, color:item.payment_type ==="CHECK"?"green":"blue"}}><i className={item.payment_type === "CHECK"?"icon-banknote":"icon-creditcards"} style={{fontSize:"18px"}}></i> {items.payment_type}</span>
                                            </div>
                                      </div>

                                    {item.payment_type === "CHECK"?
                                      <div className="col-md-2">
                                        <div className="jobs-user">
                                            Payment Notes
                                            <span>{items?.payment_details}</span>
                                            </div>
                                      </div>:null
                                    }

                                      
                                      </div>
                                    ))}
                                  </div>
                              </div>

                                

                          )

                      )):null
                      }
                      {
                          !result?
                          (<div className="nodata">
                              <h2>Sorry! No Result Found</h2>
                          </div>):null
                      }


                    {result?
                        <div className="page-title-wrpr" style={{marginTop:'40px'}}>
                            <div className="page-title-left-column">
                                Displaying {(currentpage*10 )+ 1}-{(currentpage*10 )+ counts} of {totalItems} results.
                            </div>
                            <div className="page-rightside-action-column">                          
                                <button style={{padding:"10px", background:'#4077c7', borderRadius:"5px", color:'#fff'}} class="addbtnitem-link text-anchor" onClick={exportAttendee}>Export</button>
                            </div>
                        </div>:null
                    }
  
                  </div>

                  { 
                      loader1?
                      <div>
                          <div className="loader_container"><Loader/></div>
                      </div>
                      :
                      null
                  }


                {result?
                    (
                        <div class="pagination-wrpr">
                            <ReactPaginate
                                className="pagination page"
                                pageClassName="page-item"
                                activeClassName="active"
                                nextLabel=">"
                                previousLabel="<"
                                previousClassName="page-link p-link"
                                nextClassName="page-link p-link"
                                onPageChange={handlePageClick1}
                                pageRangeDisplayed={10}
                                pageCount={totalPages}
                                renderOnZeroPageCount={1}
                            />
                        </div>
                    ):null
                } 
              </div>
          </aside>
    </div>
    )
}

export default RegitserListingDetails;